/**
 * The local storage variable name for the demo process.
 * @const {string}
 */
export const DEMO_STORAGE_NAME = 'demoTemplate';
